const Main = () => import('@pages/Main')
const Dept = () => import('@pages/contact/dept')
const UserName = () => import('@pages/contact/username')
const Group = () => import('@pages/contact/group')
const Standards = () => import('@pages/contact/standards')
const CommonPhone = () => import('@pages/contact/common_phone')
const Combination = () => import('@pages/contact/combination')

export const main = [
  {
    path: '/',
    component: Main,
    meta: {},
    children: [
      {
        path: '/dept',
        name: 'Dept',
        component: Dept,
        meta: {}
      },
      {
        path: '/username',
        name: 'UserName',
        component: UserName,
        meta: {}
      },
      {
        path: '/group',
        name: 'Group',
        component: Group,
        meta: {}
      },
      {
        path: '/standards',
        name: 'Standards',
        component: Standards,
        meta: {}
      },
      {
        path: '/common_phone',
        name: 'CommonPhone',
        component: CommonPhone,
        meta: {}
      },
      {
        path: '/combination',
        name: 'Combination',
        component: Combination,
        meta: {}
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/main.route.js